module.exports = __webpack_public_path__ + "static/media/giftsReceived_2000_3000.a15a87b8.png";